import ShelfSelectDrawer from '../Shelves/Selection/ShelfSelectDrawer';
import ListAssignDrawer from '../CollaborativeLists/ManageFromTitleOrList/ListAssignDrawer';
import TitleExport from './Export/TitleExport';

export const TitleListActionOptions = {
	AddToCollaborativeList: {
		label: 'add_to_collaborative_list',
		classNames: 'icon-community add-to-collaborative-list-icon',
		drawer: ListAssignDrawer,
	},
	AddToShelf: {
		label: 'add_to_shelf_collection',
		classNames: 'icon-books shelf-icon',
		drawer: ShelfSelectDrawer,
	},
	ShareOrExport: {
		label: 'share_or_export',
		classNames: 'icon-export share-icon',
		drawer: TitleExport,
	},
	ClearTitleSelections: {
		label: 'clear_title_selections',
		classNames: 'icon-undo share-icon',
	},
};
